export default "__VITE_ASSET__DHuEmoG6__"